import { useCallback, useEffect, useState } from 'react';

// `beforeinstallprompt` is usually fired only once, shortly after the app loads.
// Keep it outside React so it survives route changes (Profile is lazy loaded).
let installPrompt = null;
const listeners = new Set();

const notify = () => {
  listeners.forEach((listener) => listener(installPrompt));
};

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    installPrompt = event;
    notify();
  });

  window.addEventListener('appinstalled', () => {
    installPrompt = null;
    notify();
  });
}

const useInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(installPrompt);

  useEffect(() => {
    listeners.add(setDeferredPrompt);
    setDeferredPrompt(installPrompt);
    return () => listeners.delete(setDeferredPrompt);
  }, []);

  const clearInstallPrompt = useCallback(() => {
    installPrompt = null;
    notify();
  }, []);

  return { deferredPrompt, clearInstallPrompt };
};

export default useInstallPrompt;
